
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import "../Meteo/MeteoParametrizacion.css";
import { useTranslation } from 'react-i18next';

function MeteoParametrizacion(props) {

  const { t } = useTranslation();
  var getBrowserWidth = function () {
    if (window.innerWidth < 1023) {
      return "xs";
    }
  };
  const { code } = props;
  var [data, setData] = useState([])
  var [html, setHtml] = useState(<></>)

  let number = 0;
  useEffect(() => {
    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/meteo/parameters", { method: 'GET', credentials: 'include' })
      .then(async (data) => { setData(await data.json()); })
      .catch(e => { console.log(e); })

    var interval1 = setInterval(function () {
      if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/meteo/parameters", { method: 'GET', credentials: 'include' })
          .then(async (data) => { setData(await data.json()); })
          .catch(e => { console.log(e); })
      } else { // Ha cambiado de página. Cancela bucle
        clearInterval(interval1);
      }
    }, 300000)
  }, [number])

  //Cambiar el valor del mínimo
  function handleChangeMin(event) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id == event.target.id) {
        if (event.target.value !== "") {
          data[i].minValue = parseInt(event.target.value)
        } else {
          data[i].minValue = 0
        }
      }
    }
  }

  //Cambiar el valor del máximo
  function handleChangeMax(event) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id == event.target.id) {
        if (event.target.value !== "") {
          data[i].maxValue = parseInt(event.target.value)
        } else {
          data[i].maxValue = 0
        }
      }
    }
  }

  //Si queremos alarma (checkbox)
  function handleChangeAlarmLog(event) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id == event.target.id) {
        data[i].alarmLog = event.target.checked
      }
    }
  }

  //Cancelar los cambios
  function cancelarCambios() {
    setHtml(<></>)
    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/meteo/parameters", { method: 'GET', credentials: 'include' })
      .then(async (data) => { setData(await data.json()); })
      .catch(e => { console.log(e); })
  }

  //Aplicar los cambios
  function guardarCambios() {
    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/meteo/updateParameters", { method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
      .then(d => {
        if (d.status === 206) {
          setNotificationMessage('Se han aplicado los cambios correctamente.');
          setNotificationType('success');
          handleClick();
          console.log('Success')
        } else { //Dependiendo del codigo que nos da la llamada a la api nos salta un mensaje
          switch (d.status) {
            case 502:
              setNotificationMessage('No hay conexión con la API del SCADA.');
              break;
            case 401:
              setNotificationMessage('Fallo de credenciales.');
              break;
            case 403:
              setNotificationMessage('Este usuario no tiene permiso para modificar parámetros.');
              break;
            default:
              setNotificationMessage('Error aplicando los parámetros. Código ' + d.status + '.');
              break;
          }

          setNotificationType('error');
          handleClick();
        }
      }).catch(e => { setNotificationMessage('Error aplicando los parámetros.'); setNotificationType('error'); handleClick(); })
  }

  ///////////////////// Notificación
  const [open, setOpen] = React.useState(false);
  const [notificationType, setNotificationType] = useState('success');
  const [notificationMessage, setNotificationMessage] = useState('');

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  ///////////////////// Notificación

  useEffect(() => {
    //Obtenemos los id que sean distintos
    //Con new indicamos que si el id no está en el array que lo añada en la lista
    const obtenerIdMeteo = () => [...new Set(data.map((dato) => dato.idMeteo))];

    // Obtener el nombre de la Meteo a través del id guardado en sessionStorage
    const obtenerNombreMeteo = (id) => {
      return JSON.parse(sessionStorage.getItem("MeteoConfiguration")).filter(dato => dato.id === id)[0].name;
    };

    // Generamos el Html filtrando por meteo primero y después mapeando por el id.
    const generarHtml = (idMeteo) => data.filter((dato) => dato.idMeteo === idMeteo).map((dato, index) => (
      <tr key={index}>
        <td style={{ fontSize: "1em" }}>{dato.variable}</td>
        <td>
          <input className="input-meteo-para" id={dato.id} type="text" defaultValue={dato.minValue} onChange={handleChangeMin} /*style={{ width: "55px" }}*/ />
        </td>
        <td>
          <input className="input-meteo-para" id={dato.id} type="text" defaultValue={dato.maxValue} onChange={handleChangeMax} /*style={{ width: "55px" }}*/ />
        </td>
        <td className='center-text' /*style={{ textAlign:"center", verticalAlign:"middle" }}*/>
          <input id={dato.id} type="checkbox" defaultChecked={dato.alarmLog} onChange={handleChangeAlarmLog} />
        </td>
      </tr>
    ));

    // Escribimos el resto de la tabla que es común a todas las tablas
    const html = obtenerIdMeteo().map((idMeteo) => (
      <div key={idMeteo} className='col-8 col-sm-6 div-tabla-parametrizacion' >
        <h3>{obtenerNombreMeteo(idMeteo)}</h3>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>{t('scada.solarFarm.meteo.parameterization.variable')}</th>
              <th>{t('scada.solarFarm.meteo.parameterization.minValue')}</th>
              <th>{t('scada.solarFarm.meteo.parameterization.maxValue')}</th>
              <th className='center-text' /*</tr>style={{ textAlign:"center", verticalAlign:"middle" }}*/>{t('scada.solarFarm.meteo.parameterization.logs')}</th>
            </tr>
          </thead>
          <tbody>{generarHtml(idMeteo)}</tbody>
        </Table>
      </div>
    ));

    setHtml(html);
  }, [data]);

  return <div id='container-meteo-para' className='container-fluid' /*style={{ marginTop: '15px',maxHeight: 'calc(100vh - 65px)',maxWidth:'100%'}}*/>
    <div id="first-row" className="row" /*style={{height:"81vh", overflowY:"scroll"}}*/>
      {html}
    </div>
    <div i8d="second-row" className="row justify-content-end" /*style={{ marginRight: "5%", marginTop:"1%" }}*/>
      <a className='active-meteo-button para-meteo-buttons' onClick={cancelarCambios} style={{ maxWidth: "100px", textAlign: "center", marginRight: "5%", textDecoration: 'none' }}>{t('scada.solarFarm.meteo.parameterization.cancel')}</a>
      <a className='active-meteo-button para-meteo-buttons' onClick={guardarCambios} style={{ maxWidth: "100px", textAlign: "center", textDecoration: 'none' }}>{t('scada.solarFarm.meteo.parameterization.save')}</a>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity={notificationType} sx={{ width: '40%' }}>
          {notificationMessage}
        </Alert>
      </Snackbar>
    </div>
  </div>;
}

export default MeteoParametrizacion